import { Component, OnInit, OnDestroy, AfterViewChecked, HostListener } from '@angular/core';
//import { Helpers } from '../helpers/helpers';
import { UserInfoService } from './../services/user-info.service';
import { IUser } from './../models/user.model';
import { Subscription } from 'rxjs';
import { ZpDataService } from 'src/app/services/zp-data.service';
import { Router } from '@angular/router';
//import { FinancialItemIdService } from './../services/financial-item-id.service';
import { FinancialSummaryCategoriesSetFilterService } from './../services/financial-items-set-filter.service';
import { FinancialSectionsSetFilterService } from './../services/financial-sections-set-filter.service';
import plantree from '../../assets/data/plan-tree.json';
import { FinancialSummaryModeService } from './../services/financial-summary-mode.service';
import { SideNavBarVisibilityService } from '../services/side-nav-bar-visibility.service';
import { ThemeService } from '../theme/theme-service.service';
import { HttpParams } from '@angular/common/http';

@Component({
    selector: 'app-financial-summaries',
    templateUrl: './financial-summaries.component.html',
    styleUrls: ['./financial-summaries.component.scss'],
    standalone: false
})
export class FinancialSummariesComponent implements OnInit, AfterViewChecked {
  public myUser: IUser;
  public subscription: Subscription;
  public subscription2: Subscription;
  public subscription3: Subscription;
  public myCategoriesBalance;
  public myCategoriesBalanceWithJointOwnership;
  public myCategoriesBalanceWithoutJointOwnership;
  public myCategoryFilter;
  public filter;
  public assets = 0;
  public debts = 0;
  public income = 0;
  public expense = 0;
  public tooltip =
    'If you have jointly owned items in your plan, selecting this option will include the joint owner\'s share in your Financial Summary.';
  public dataIsLoaded: boolean = false;
  public jointOwnersStats = false;
  public sectionName = 'bank-account';
  public itemId;
  public propertyTemplateName = 'property-view';
  public financialSummaryMode: boolean = true;
  public noItems: boolean;
  public showSectionViewBox: boolean;
  public questionMarkMobile: boolean;
  public statusTooltipMobile;
  public statusExplanations;
  public activeTheme: any;
  public isDefaultTheme: boolean;
  public statusOwnersListMenu: boolean;
  public financialSummarySelectedOwners: any = [];
  public selectedOwners: any = {};
  public isOwnerSelected: boolean = true;
  public ownersWithProperty: any = [];
  public sharedPlanCategories: any;
  public ownersHashmap: {} = {}
  public mySharedPlans: {}[];
  public hasPlan: any;

  constructor(
    private userInfo: UserInfoService,
    private financialNetCategoriesSetFilterService: FinancialSummaryCategoriesSetFilterService,
    public zenplanData: ZpDataService,
    private router: Router,
    private financialSummaryModeService: FinancialSummaryModeService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private financialNetCategoriesService: FinancialSummaryCategoriesSetFilterService,
    private financialSectionsSetFilterService: FinancialSectionsSetFilterService,
    public themeService: ThemeService
  ) {
  }

  async categoriesBalance(myJointOwnersStats) {
    console.log(this.myUser);
    this.assets = this.debts = this.income = this.expense = 0;
    // if (myJointOwnersStats) {
    //   if (this.myCategoriesBalanceWithJointOwnership) {
    //     this.myCategoriesBalance = this.myCategoriesBalanceWithJointOwnership;
    //   } else {
      this.myCategoriesBalance =
      await this.zenplanData.getAllFinancialSummaryInfo(!this.myUser.sharedPlanUserId ? this.myUser : {sharedPlanUserId: this.myUser.sharedPlanUserId, jointOwners: this.ownersWithProperty}, false, this.financialSummarySelectedOwners);
    //     this.myCategoriesBalanceWithJointOwnership = this.myCategoriesBalance;
    //   }
    // } else {
    //   //without joint ownership calc
    //   if (this.myCategoriesBalanceWithoutJointOwnership) {
    //     this.myCategoriesBalance =
    //       this.myCategoriesBalanceWithoutJointOwnership;
    //   } else {
    //     this.myCategoriesBalance =
    //       await this.zenplanData.getAllFinancialSummaryInfo(this.myUser, true);
    //     this.myCategoriesBalanceWithoutJointOwnership =
    //       this.myCategoriesBalance;
    //   }
    // }
    
    if (this.myCategoriesBalance == undefined) {
      this.noItems = true;
    } else {
      console.log('myCategoriesBalance - ', this.myCategoriesBalance);
      this.assets = this.myCategoriesBalance['assetTotal'];
      this.debts = this.myCategoriesBalance['debtTotal'];
      this.income = this.myCategoriesBalance['incomeTotal'];
      this.expense = this.myCategoriesBalance['expenseTotal'];
      console.log('assets - ', this.assets);
      console.log('debts - ', this.debts);
      console.log('income - ', this.income);
      console.log('expense - ', this.expense);
      let sectionFriendlyName = this.myCategoriesBalance['sections'][0];
      let basename = '';
      plantree.forEach(function (category) {
        let mySection = category.sectionObjects.filter(
          (section) => { section.section == sectionFriendlyName; }
        );
        if (mySection.length > 0) {
          basename = mySection[0].baseName;
        }
      });
      this.sectionName = basename; //this.myCategoriesBalance["sections"][0]["sectionName"];
      //this.financialNetCategoriesSetFilterService.changeMessage(this.myCategoryFilter);
      if (
        this.assets == 0 &&
        this.debts == 0 &&
        this.income == 0 &&
        this.expense == 0
      ) {
        this.noItems = true;
      } else {
        this.noItems = false;
      }
    }
  }

  async ngOnInit() {
    this.activeTheme = this.themeService.active;
    if (this.activeTheme.name != 'defaultTheme') {
      this.isDefaultTheme = false;
    }
    this.isOwnerSelected = true;
    this.jointOwnersStats = false;
    
    this.subscription = this.userInfo.getMessage().subscribe(async (user) => {
      this.myUser = JSON.parse(user);
      this.mySharedPlans = await this.zenplanData.getMySharedPlans(
        this.myUser["Id"]
      );
      this.hasPlan = await this.zenplanData.getPlan(this.myUser["Id"]);
      if (this.myUser || this.myUser.sharedPlanUserId) { // we need to only display joint owners with property in the list.
        this.ownersWithProperty = [];
        const plan = await this.zenplanData.retrieveData( // retrieve the plan
          'get',
          '/api/plan',
          new HttpParams().set('clientId', this.myUser.Id)
        );
         // iterate through the jointOwners and only add those owners who own something.
          if (this.myUser && !this.myUser.sharedPlanUserId) {
            for (const jointOwner of this.myUser.jointOwners) {
              const ownedItems = this.zenplanData.findItemsOwnedByOwner(plan, jointOwner);
              if (ownedItems && ownedItems.length) {
                this.ownersWithProperty.push(jointOwner);
              }
            }
            console.log('myUser this.ownersWithProperty - ', this.ownersWithProperty)
          }
          if (this.myUser.sharedPlanUserId) {
            this.sharedPlanCategories = await this.zenplanData.getPlan(this.myUser.sharedPlanUserId);
            console.log('sharedPlanCategories - 2', this.sharedPlanCategories)
            if (this.sharedPlanCategories) {
              for (let itemType in this.sharedPlanCategories) {
                for (let item of this.sharedPlanCategories[itemType]) {
                  console.log('item! -', item)
                  if (item.newJointOwners) {
                    for (let owner of item.newJointOwners) {
                      console.log('owner - ', owner)
                      this.ownersHashmap[owner.owner.first + owner.owner.last] = owner.owner;
                      // console.log('this.ownersSelectedHashmap - ', this.ownersSelectedHashmap)
                      // this.test.push(this.ownersSelectedHashmap)
                    }
                  }
                }
              }
              this.ownersWithProperty = this.zenplanData.displaySharedPlansOwner(Object.values(this.ownersHashmap))
              console.log('shared Plans this.ownersWithProperty - ', this.ownersWithProperty)
            }
          }
        if (this.ownersWithProperty && this.ownersWithProperty.length === 0) {
          if (this.myUser) {
                this.ownersWithProperty = this.myUser.jointOwners.slice();
              // in case we don't find owners who own something OR the plan hasn't loaded, default to displaying all jointOwners
          }
        }
      }

      if (this.financialSummarySelectedOwners.length === 0) {
        
        this.ownersWithProperty.find((itm) => {
          if (itm.default == true) {
            this.selectedOwners[itm.first + itm.last] = true;
            this.financialSummarySelectedOwners.push(itm);
            this.isOwnerSelected = true
          }
          if (this.myUser && this.financialSummarySelectedOwners.length === 0) {
            if (this.myUser && this.myUser.jointOwners) {
            this.financialSummarySelectedOwners.push(this.myUser.jointOwners[0])
            }
          }
        });
        // if (this.myUser) {
        //   this.ownersWithProperty.find((itm) => {
        //     if (itm.first === this.myUser.firstName) {
        //       this.selectedOwners[itm.first + itm.last] = true;
        //       this.financialSummarySelectedOwners.push(itm);
        //       // console.log(
        //       //   'ngOnInit(), financialSummarySelectedOwners - ',
        //       //   this.financialSummarySelectedOwners
        //       // );
        //       this.isOwnerSelected = true
        //     }
        //   });
        // }
        // if (this.myUser.sharedPlanUserId) {
        //   this.ownersWithProperty.find((itm) => {
        //     console.log('itm - ', itm)
        //   });
        // }
        
      }


      if (this.myUser) {
        this.dataIsLoaded = false;
        await this.categoriesBalance(this.jointOwnersStats);
        this.financialNetCategoriesSetFilterService.changeMessage('assets');
        this.dataIsLoaded = true;
      }
    });
    this.subscription2 = this.financialSummaryModeService
      .getMessage()
      .subscribe((mode) => {
        this.financialSummaryMode = JSON.parse(mode);
        this.showSectionViewBox = false;
      });
    this.subscription3 = this.financialSectionsSetFilterService
      .getMessage()
      .subscribe((filter) => {
        this.showSectionViewBox = true;
      });
    // this.subscription2 = await this.financialItemIdService.getMessage().subscribe(async Id => {
    //   this.itemId = Id;
    // });
    if (window.screen.width <= 1100) {
      this.questionMarkMobile = true;
    } else {
      this.questionMarkMobile = false;
    }
  }

  async getCurrentOwnerSelected(ev, owner) {
    // this is called whenever a jointOwner is selected or unselected from the dropdown list.
    if (ev.target.checked) {
      this.financialSummarySelectedOwners.push(owner);
      // this.zenplanData.setCurrentOwnerSelected(this.financialSummarySelectedOwners);
    } else {
      const ownerToRemove = this.financialSummarySelectedOwners.find(
        (itm) => itm.first + itm.last === owner.first + owner.last
      );
      if (ownerToRemove) {
        this.financialSummarySelectedOwners.splice(
          this.financialSummarySelectedOwners.indexOf(ownerToRemove),
          1
        );
      }
    }
    if (this.financialSummarySelectedOwners.length > 0) {
      this.isOwnerSelected = true;
    } else {
      this.isOwnerSelected = false;
    }
    //copied from toggle.
    await this.categoriesBalance(false);
    // console.log('cataegoriesBalance - ', this.categoriesBalance(false))
    // this.financialNetCategoriesSetFilterService.changeMessage("assets");
    this.showSectionViewBox = false;
    //this.closeOwnersListMenu(ev);

  }

  async toggledViewJointOwnersStats(jointOwnersStats) {
    await this.categoriesBalance(jointOwnersStats);
    // console.log('cataegoriesBalance - ', this.categoriesBalance(jointOwnersStats))
    // this.financialNetCategoriesSetFilterService.changeMessage("assets");
    this.showSectionViewBox = false;
  }

  async ngAfterViewChecked() {
    //await this.financialFilterService.changeMessage("assets");
  }

  openOwnersListMenu($event) {
    $event.stopPropagation();
    this.statusOwnersListMenu = !this.statusOwnersListMenu;
  }

  @HostListener('document:click')
  onDocumentClick() {
    this.statusOwnersListMenu = false;
  }

  ngDestroy() {
    this.subscription.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
  }
}
